var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.dialog, "max-width": "500", persistent: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.confirm.apply(null, arguments)
                },
              },
            },
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(
                    _vm._s(_vm.reset ? "Blanquear contraseña" : "Crear acceso")
                  ),
                ]),
              ]),
              _c("v-card-text", [
                _c("p", { staticClass: "mb-2 text-left" }, [
                  _vm._v(" Usuario: "),
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.reset && _vm.legajo.access
                          ? _vm.legajo.access.email
                          : _vm.legajo.email
                      )
                    ),
                  ]),
                ]),
                _c("p", { staticClass: "mb-0 text-left" }, [
                  _vm._v(
                    " Ingrese una contraseña temporal y pásesela al empleado. En el primer ingreso el sistema le pide cambiarla, así solo él la conoce. "
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              min: 8,
                              regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/,
                            },
                            expression:
                              "{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/ }",
                          },
                        ],
                        attrs: {
                          label: "Contraseña temporal*",
                          name: "password",
                          "data-vv-as": "contraseña",
                          type: _vm.show ? "text" : "password",
                          "append-icon": _vm.show ? "mdi-eye" : "mdi-eye-off",
                          hint: "Al menos 8 caracteres, con letras y números",
                        },
                        on: {
                          "click:append": function ($event) {
                            _vm.show = !_vm.show
                          },
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("password"))),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text-left" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "px-0",
                              attrs: { small: "", text: "", color: "primary" },
                              on: { click: _vm.generate },
                            },
                            [_vm._v("Generar contraseña")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        text: "",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        text: "",
                        type: "submit",
                        loading: _vm.loading,
                      },
                    },
                    [_vm._v(_vm._s(_vm.reset ? "Guardar" : "Crear acceso"))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }